import { useEffect, useState, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router";
import axios from 'axios';

import { AppContext } from '../../context.js';
import { FilePlus, Search, Plus, CheckCircle, Phone, Bell, ChevronDown } from "../../files/icons/index.js";

import Drop from "../components/drop.js";

import { Status, Button } from '../components/component.js';
import Loading from '../components/loading.js';
import Helmet from "../components/helmet.js";

import { DatetimeToDate, DateToFormat } from "../../utils/datetime.js";

function Intakes(props) {
  const { notificationObject } = props;

  const context = useContext(AppContext);

  const navigate = useNavigate();

  // Search params
  const [searchParams] = useSearchParams();
  const templateID = searchParams.get('templateID');
  const importID = searchParams.get('importID');

  const [loading, setLoading] = useState(true);

  // Search
  const step = 10;
  const [prompt, setPrompt] = useState(null);
  const [filter, setFilter] = useState({
    // role: ["patient"],
    templateID: templateID ? [templateID] : null,
    importID: importID ? [importID] : null,
    statusType: ["TO_DO"],
    //archived: false,
  });
  const [limit, setLimit] = useState(step);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);

  // Data
  const [referrals, setReferrals] = useState([]);
  const [settings, setSettings] = useState(null);

  // Creating a new intake
  const [closeCreateIntakeDrop, setCloseCreateIntakeDrop] = useState(0);
  const [createIntake, setCreateIntake] = useState({
    visible: false,
    template: null,
  });

  // Initial data load
  // Default limit and offset used
  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.post('/api/admin/intakes', {
        prompt: prompt,
        filter: filter,
        limit: limit,
        offset: offset,
      }),
      axios.get('/api/admin/settings', {
      }),
    ]).then(axios.spread((intakes, settings) => {
      setFilter(intakes.data.filter);
      setReferrals(intakes.data.intakes);
      setCount(intakes.data.count);

      setSettings(settings.data);

      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  // Load more patients
  // Limit and offset moved forward by step
  function extendLimit() {
    let u = context.addSpiner();
    axios.post('/api/admin/intakes', {
      prompt: prompt,
      filter: filter,
      limit: limit+step,
      offset: limit,
    }).then((response) => {
      setFilter(response.data.filter);
      setReferrals((prevReferrals) => {
        const newReferrals = response.data.intakes.filter(
          (newReferral) => !prevReferrals.some((prevReferral) => prevReferral.id === newReferral.id)
        );
        return [...prevReferrals, ...newReferrals];
      });
      setLimit(response.data.limit);
      setOffset(response.data.offset);
      setCount(response.data.count);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  // Prompt search fired
  // Limit and offset reset to default
  function search() {
    let u = context.addSpiner();
    axios.post('/api/admin/intakes', {
      prompt: prompt,
      //filter: {role: ["patient"], archived: false},
      limit: step,
      offset: 0,
    }).then((response) => {
      setFilter(response.data.filter);
      setReferrals(response.data.intakes);
      setLimit(response.data.limit);
      setOffset(response.data.offset);
      setCount(response.data.count);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  // Create intake
  function createIntakeOnClick(template) {
    setCreateIntake({
      visible: true,
      template: template,
    });
    setCloseCreateIntakeDrop(closeCreateIntakeDrop + 1);
  }

  function closeCreateIntakeModal() {
    setCreateIntake({ visible: false });
  }

  function createIntakeConfirm() {
    let u = context.addSpiner();
    axios.post('/api/admin/intakes/create', {
      templateID: createIntake.template.id,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      message: '',
      form: {},
    }).then((response) => {
      navigate(`/intake/${response.data.id}`);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  function renderIntakeTemplates() {
    if (!settings.intakeTemplates || settings.intakeTemplates.length === 0) {
      return (
        <div className="item" style={{minWidth: 400}}>
          <div className="w-100">
            <div className="typo-header-150 text-muted">No templates available</div>
            <div className="typo-normal-125 text-muted">No intake templates configured yet</div>
          </div>
        </div>
      );
    }

    return settings.intakeTemplates.map((template) => {
      return (
        <div key={template.id} className="item" style={{minWidth: 400}} onClick={() => createIntakeOnClick(template)}>
          <div className="w-100">
            <div className="typo-header-150">{template.title}</div>
            <div className="typo-normal-125">{template.description}</div>
          </div>
        </div>
      );
    });
  }

  function renderFilters() {
    return (
      <div className="d-flex justify-content-start align-items-center ps-4 ">
        <div className="item typo-normal-150 text-muted"><Plus width={16} height={16} color={'grey'} /> Website Call</div>
      </div>
    );
  }

  // Render helpers
  function renderReferrals() {
    var filteredReferrals = referrals;
    // if (searchText !== "") {
    //   filteredProfiles = filteredProfiles.filter((profile) => {
    //     return profile.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
    //     profile.lastName.toLowerCase().includes(searchText.toLowerCase());
    //   });
    // }

    if (filteredReferrals.length === 0) {
      return (
        <div className="d-flex justify-content-center align-items-center mt-4">
          <div className="typo-normal-150 text-muted">No intakes found</div>
        </div>
      );
    }

    return filteredReferrals.map((referral) => {
      return (
        <div onClick={() => navigate(`/intake/${referral.id}`)} className="card clickable mb-2">
          <div className="card-content sm">
            <div className="row">
              <div className="col-xs-3">
                <div className="typo-strong-175">{referral.firstName + " " + referral.lastName}</div>
                <div className="typo-normal-150">{referral.selfReferral ? "Self Referral" : referral.partnerName}</div>
              </div>
              <div className="col-xs-3">
                <div className="typo-normal-150">{referral.message}</div>
              </div>
              <div className="col-xs-3 col-xs-offset-1">
                {/* {renderAction('phone', 'Call tomorrow to discuss opportunity')}
                {renderAction('bell', 'Tomorrow is the visit date')}
                {renderAction('check-circle', 'Send follow-up email after visit')} */}
              </div>
              <div className="col-xs-2 text-end">
                {referral.statusType === "TO_DO" && (
                  <Status color={'grey'} muted={true} text={'To Do'} />
                )}
                {referral.statusType === "COMPLETED" && (
                  <Status color={'green'} muted={true} text={'Completed'} />
                )}
                {referral.statusType === "CANCELED" && (
                  <Status color={'red'} muted={true} text={'Archived'} />
                )}
                <div className="typo-normal-125 mt-2">{DateToFormat(DatetimeToDate(referral.createdAt), context.dateFormat)} {DateToFormat(DatetimeToDate(referral.createdAt), context.timeFormat === "us" ? "AMPM" : "HH:mm")}</div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  function renderAction(icon, title) {
    let i;
    switch (icon) {
      case 'phone':
        i = <Phone width={16} height={16} color={'grey'} />;
        break;
      case 'bell':
        i = <Bell width={16} height={16} color={'grey'} />;
        break;
      case 'check-circle':
        i = <CheckCircle width={16} height={16} color={'grey'} />;
        break;
      default:
        i = null;
    }
    return (
      <div className="d-flex justify-content-start align-items-center typo-normal-150 mb-1">{i} <span className="ms-2">{title}</span></div>
    );
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet title="Intakes" />

      {createIntake.visible && (
        <div className="fixed-bottom modal-bg" onClick={(e) => closeCreateIntakeModal()}>
          <div className="container" style={{paddingTop: '5%'}}>
            <div className="row">
              <div className="col-xs-6 col-xs-offset-3">
                <div className="card shadowmore" onClick={(e) => {e.stopPropagation()}}>
                  <div className="card-header">
                    <span className="typo-header-3xLarge">Create {createIntake.template.title}</span><br/>
                    <span className="typo-normal-175">An empty intake form will be created. You can fill it out later.</span>
                  </div>
                  <div className="card-content text-end">
                    <Button onClick={closeCreateIntakeModal} color="grey" text="Cancel" />
                    <Button onClick={createIntakeConfirm} color="blue" text="Create" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container">
        <div className="row mb-4">
          <div className="col-xs-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex justify-content-between align-items-center">
                <span className="typo-hero-small">Intakes</span>
                {/* <span className="typo-normal-175 mt-2 ms-3">Here is an overview of your demographic information</span> */}
              </div>
              <div className="w-25 text-end">
                <Drop close={closeCreateIntakeDrop} side={"right"}>
                  <div className="item typo-normal-150 ms-2"><FilePlus height={16} width={16} color={'grey'} /> Create Intake</div>
                  <div className="card shadowmore text-start" style={{width: 'fit-content'}}>
                    <div className="card-header sm">
                      {renderIntakeTemplates()}
                    </div>
                  </div>
                </Drop>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            
            <div className="card shadowmore mb-4">
              <div className="card-content sm">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-start align-items-center w-100">
                    <Search width={16} height={16} color={'grey'} />
                    <input type="text" className="input borderless w-100 ms-2" placeholder="Type and press enter to search..." value={prompt || ''} onChange={(e) => setPrompt(e.target.value)} onKeyUp={(e) => e.key === 'Enter' && search()} autoFocus={true} />
                  </div>
                  <div style={{minHeight: 28}}>
                  </div>
                </div>
              </div>
            </div>

            {/* {renderFilters()} */}

            {renderReferrals()}

            {(count !== 0 && limit < count) && (
              <div className="d-flex justify-content-center align-items-center">
                <div className="item typo-normal-150" onClick={() => extendLimit()}>show more</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Intakes;
